export interface DataEntity_Working_07_Interface {
    id: number,
    max_value:string,
    min_value:string,
  }
  
  export function Empty_DataEntity_Working_07_Interface(): DataEntity_Working_07_Interface {
    return {
      id: 0,
      max_value:'',
      min_value:'',
    }
  }
  